import script from "./DevicesList.vue?vue&type=script&setup=true&lang=js"
export * from "./DevicesList.vue?vue&type=script&setup=true&lang=js"

import "./DevicesList.vue?vue&type=style&index=0&id=36efd62a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36efd62a"]])

export default __exports__